<div class="container-fluid form-horizontal wl-event-setting-top-box-container highlight-box">
  <div *ngIf="!isLoading && event?.Version == 3" class="wl-event-setting-top-box-inner">
    <div class="row">
      <div class="col-sm-5 col-sm-push-7 col-lg-4 col-lg-push-8 text-right">
        <div class="form-control-static">
          <wl-copy-event [event]="event" title="{{ 'events.settings.copy-event-tooltip' | translate | titlecase }}"></wl-copy-event>

          <button
            pButton
            type="button"
            class="btn btn-danger"
            (click)="deleteClick()"
            [disabled]="userAccessLevel < 2"
            icon="pi pi-trash"
            [pTooltip]="'events.settings.delete-event-tooltip' | translate | titlecase"
          ></button>

          <div [hidden]="!event?.EventId" class="mt-2">
            <a
              [href]="
                tenantHttpsUrl +
                '/events/' +
                (event?.EventName | wlRegexReplace: '[\\W_-]+' : 'g' : '-') +
                '-' +
                event?.EventId +
                '/details'
              "
              target="_blank"
              class="font-weight-bold"
            >
              <i class="pi pi-external-link mr-1"></i>
              {{ 'events.detail.component.view-web-page' | translate }}
            </a>
          </div>

          <div class="wl-event-settings-event-button-space hidden-xs"></div>
        </div>
      </div>

      <div class="col-sm-7 col-sm-pull-5 col-lg-8 col-lg-pull-4">
        <h2 *ngIf="event" class="mt-0">
          {{ event?.EventName }} <span class="small text-muted">({{ event?.EventId }})</span>
        </h2>

        <div class="mb-3">
          <button app-add-button
            dataCy="btnEventSettingsNewRegistration"
            [label]="'events.settings.new-registration-label' | translate | titlecase"
            (onClick)="handleNewRegistrationClick()"
          >
          </button>
        </div>

        <p class="lead mb-1">
          <i class="pi pi-calendar mr-2"></i>
          {{ event?.StartDate | date: 'fullDate' }}<span *ngIf="event?.StartTime">, {{ event?.StartTime }}</span>
          <span *ngIf="(event?.StartDate | date: 'yMd') != (event?.EndDate | date: 'yMd')">
            - {{ event?.EndDate | date: 'fullDate' }}<span *ngIf="event?.EndTime">, {{ event?.EndTime }}</span>
          </span>
          <span
            *ngIf="
              (event?.StartDate | date: 'yMd') == (event?.EndDate | date: 'yMd') && event?.EndTime && event?.StartTime != event?.EndTime
            "
          >
            - {{ event?.EndTime }}
          </span>
        </p>

        <address class="wl-event-settings-address-display text-muted">
          <i class="pi pi-map-marker mr-2"></i>
          <strong>{{ event?.Venue }}</strong
          ><br />
          {{ event?.Address1 }} {{ event?.Address2 }}<br />
          {{ event?.City }}{{ event?.City && event?.State ? ', ' : '' }} {{ event?.State }} {{ event?.Zip }}
        </address>
      </div>
    </div>

    <div class="wl-event-setting-desktop-save-button hidden-xs">
      <wl-busy [show]="isSaving"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-primary"
        [disabled]="userAccessLevel < 2 || isSaving || isLoading || !registrationSettingsTab.valid"
        (click)="saveEvent()"
        icon="pi pi-save"
        [label]="(isSaving ? 'common.saving' : 'common.save') | translate | titlecase"
      ></button>
    </div>
  </div>

  <div class="row" *ngIf="isLoading">
    <div class="col-xs-12 text-center p-4">
      <wl-busy [show]="isLoading"></wl-busy>
      <span class="ml-2">{{ 'common.loading' | translate | titlecase }}...</span>
    </div>
  </div>

  <div class="row" *ngIf="!isLoading && event?.EventId > 0 && event?.Version != 3">
    <div class="col-xs-12 alert alert-warning">
      <i class="pi pi-info-circle mr-2"></i>
      <span [hidden]="event?.Version != 0">{{ 'events.settings.edit-not-allowed-for-version-1-message' | translate }}</span>
      <span [hidden]="event?.Version != 2">{{ 'events.settings.edit-not-allowed-for-version-2-message' | translate }}</span>
    </div>
  </div>

  <div class="row" *ngIf="!isLoading && event?.EventId <= 0">
    <div class="col-xs-12 alert alert-danger">
      <i class="pi pi-exclamation-circle mr-2"></i>
      {{ 'events.settings.event-not-found-error-message' | translate | ucfirst }}
    </div>
  </div>
</div>

<div [hidden]="event?.Version != 3" class="wl-event-setting-save-button-container pull-right visible-xs-block px-3">
  <wl-busy [show]="isSaving"></wl-busy>
  <button
    pButton
    type="button"
    class="btn btn-primary"
    [disabled]="userAccessLevel < 2 || isSaving || isLoading"
    (click)="saveEvent()"
    icon="pi pi-save"
    [label]="(isSaving ? 'common.saving' : 'common.save') | translate | titlecase"
  ></button>
</div>

<wlx-tabs #tabsContainer [hidden]="event?.Version != 3">
  <wlx-tab [title]="'events.dashboard.tab-title' | translate | titlecase">
    <wl-event-dashboard
      #eventDashboardCtrl
      [tabContainer]="tabsContainer"
      [registrationTab]="registrationstab"
      [registrationManagementCtrl]="registrationManagement"
      [event]="event"
    >
    </wl-event-dashboard>
  </wlx-tab>

  <wlx-tab #registrationstab [title]="'events.registration.management.tab-title' | translate | titlecase">
    <wl-registration-management #registrationManagement [event]="event"></wl-registration-management>
  </wlx-tab>

  <wlx-tab #attendeestab [title]="'events.attendees.management.tab-title' | translate | titlecase">
    <wl-attendee-management #attendeeManagement [event]="event"></wl-attendee-management>
  </wlx-tab>

  <wlx-tab #eventSettingsTab [title]="'events.settings.title' | translate | titlecase">
    <wlx-tab #generalSettingsTab [title]="'events.settings.general.title' | translate | titlecase">
      <wl-event-settings-general [event]="event" [(showEditor)]="generalSettingsTab.selected"></wl-event-settings-general>
    </wlx-tab>

    <wlx-tab #eventItemsTab [title]="'events.settings.items.title' | translate | titlecase">
      <wl-event-settings-items *ngIf="eventItemsTab.selected" (eventItemsListChange)="eventItemsListChanged()" [event]="event">
      </wl-event-settings-items>
    </wlx-tab>

    <wlx-tab #registrationSettingsTab [title]="'events.settings.registration.settings.title' | translate | titlecase">
      <wl-event-settings-registration-settings
        [event]="event"
        (onValidChange)="registrationSettingsTab.valid = $event"
        [(showEditor)]="registrationSettingsTab.selected"
      >
      </wl-event-settings-registration-settings>
    </wlx-tab>

    <wlx-tab #eventRegistrationFieldsTab [title]="'events.settings.registration-fields.title' | translate | titlecase">
      <wl-event-settings-registration-fields *ngIf="eventRegistrationFieldsTab.selected" [event]="event">
      </wl-event-settings-registration-fields>
    </wlx-tab>

    <wlx-tab #eventPromoCodesTab title="Promo Codes">
      <wl-event-settings-promo-codes *ngIf="eventPromoCodesTab.selected" [eventId]="event.EventId" [event]="event">
      </wl-event-settings-promo-codes>
    </wlx-tab>

    <wlx-tab #eventBenefitsTab [enabled]="hasEventBenefits" [title]="'events.settings.benefits.title' | translate | titlecase">
      <wl-event-settings-benefits *ngIf="eventBenefitsTab.selected" [event]="event"></wl-event-settings-benefits>
    </wlx-tab>

    <wlx-tab #eventSponsorsTab [title]="'events.settings.sponsors.title' | translate | titlecase">
      <wl-event-settings-sponsors *ngIf="eventSponsorsTab.selected"></wl-event-settings-sponsors>
    </wlx-tab>
  </wlx-tab>
</wlx-tabs>

<p-dialog
  #unsavedChangesModal
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <div class="p-3 text-center">
    <i class="pi pi-exclamation-triangle text-warning mb-3" style="font-size: 2rem"></i>
    <p>{{ 'events.settings.unsaved-changes-message' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-10">
      <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>

      <button
        pButton
        type="button"
        class="btn btn-primary"
        [disabled]="isSaving || !registrationSettingsTab.valid"
        (click)="handleUnsavedChangesModalSaveClick()"
        icon="pi pi-save"
        [label]="(isSaving ? 'common.saving' : 'common.save') | translate | titlecase"
      ></button>

      <button
        pButton
        type="button"
        class="btn btn-secondary"
        (click)="handleUnsavedChangesModalCancelClick()"
        [disabled]="isSaving"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>

      <button
        pButton
        type="button"
        class="btn btn-default"
        (click)="handleUnsavedChangesModalNoClick()"
        [disabled]="isSaving"
        icon="pi pi-times"
        [label]="'common.no' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
